import { useMutation } from "react-query";
import { paymentService } from "../services";
import { bugSnagNotifyAPIError } from "../helpers/bugSnagHelper";

const addPaymentMethod = async (newPaymentMethod: any) => {
    try{
        const response = await paymentService.addPaymentMethod(newPaymentMethod)
        return response.data.data;    
    }catch(error){
        throw error
    }
};

export default function useAddPaymentMethod() {
    return useMutation((data: { newPaymentMethod: any }) =>
        addPaymentMethod(data.newPaymentMethod)
    );
}
